module.exports = "<div class=\"personal__link js-login\" data-element-click=\"headline__login\">Войти</div>\n";


//////////////////
// WEBPACK FOOTER
// ./daily/assets/id/header/desktop/templates/unauthorized.tpl
// module id = 943
// module chunks = 11